// Generated by scripts/update-windows-zones.mjs - do not edit by hand.
// Windows ids: CLDR windowsZones.xml (https://raw.githubusercontent.com/unicode-org/cldr/main/common/supplemental/windowsZones.xml), territory 001, typeVersion 2021a.
// Display labels: node-ical windowsZones.json. Every target was valid in Intl.DateTimeFormat when generated.

/** Windows time zone id (as Outlook/Exchange write it in TZID) -> IANA zone. */
export const WINDOWS_ZONE_IDS: Readonly<Record<string, string>> = {
  "AUS Central Standard Time": "Australia/Darwin",
  "AUS Eastern Standard Time": "Australia/Sydney",
  "Afghanistan Standard Time": "Asia/Kabul",
  "Alaskan Standard Time": "America/Anchorage",
  "Aleutian Standard Time": "America/Adak",
  "Altai Standard Time": "Asia/Barnaul",
  "Arab Standard Time": "Asia/Riyadh",
  "Arabian Standard Time": "Asia/Dubai",
  "Arabic Standard Time": "Asia/Baghdad",
  "Argentina Standard Time": "America/Buenos_Aires",
  "Astrakhan Standard Time": "Europe/Astrakhan",
  "Atlantic Standard Time": "America/Halifax",
  "Aus Central W. Standard Time": "Australia/Eucla",
  "Azerbaijan Standard Time": "Asia/Baku",
  "Azores Standard Time": "Atlantic/Azores",
  "Bahia Standard Time": "America/Bahia",
  "Bangladesh Standard Time": "Asia/Dhaka",
  "Belarus Standard Time": "Europe/Minsk",
  "Bougainville Standard Time": "Pacific/Bougainville",
  "Canada Central Standard Time": "America/Regina",
  "Cape Verde Standard Time": "Atlantic/Cape_Verde",
  "Caucasus Standard Time": "Asia/Yerevan",
  "Cen. Australia Standard Time": "Australia/Adelaide",
  "Central America Standard Time": "America/Guatemala",
  "Central Asia Standard Time": "Asia/Bishkek",
  "Central Brazilian Standard Time": "America/Cuiaba",
  "Central Europe Standard Time": "Europe/Budapest",
  "Central European Standard Time": "Europe/Warsaw",
  "Central Pacific Standard Time": "Pacific/Guadalcanal",
  "Central Standard Time": "America/Chicago",
  "Central Standard Time (Mexico)": "America/Mexico_City",
  "Chatham Islands Standard Time": "Pacific/Chatham",
  "China Standard Time": "Asia/Shanghai",
  "Cuba Standard Time": "America/Havana",
  "Dateline Standard Time": "Etc/GMT+12",
  "E. Africa Standard Time": "Africa/Nairobi",
  "E. Australia Standard Time": "Australia/Brisbane",
  "E. Europe Standard Time": "Europe/Chisinau",
  "E. South America Standard Time": "America/Sao_Paulo",
  "Easter Island Standard Time": "Pacific/Easter",
  "Eastern Standard Time": "America/New_York",
  "Eastern Standard Time (Mexico)": "America/Cancun",
  "Egypt Standard Time": "Africa/Cairo",
  "Ekaterinburg Standard Time": "Asia/Yekaterinburg",
  "FLE Standard Time": "Europe/Kiev",
  "Fiji Standard Time": "Pacific/Fiji",
  "GMT Standard Time": "Europe/London",
  "GTB Standard Time": "Europe/Bucharest",
  "Georgian Standard Time": "Asia/Tbilisi",
  "Greenland Standard Time": "America/Godthab",
  "Greenwich Standard Time": "Atlantic/Reykjavik",
  "Haiti Standard Time": "America/Port-au-Prince",
  "Hawaiian Standard Time": "Pacific/Honolulu",
  "India Standard Time": "Asia/Calcutta",
  "Iran Standard Time": "Asia/Tehran",
  "Israel Standard Time": "Asia/Jerusalem",
  "Jordan Standard Time": "Asia/Amman",
  "Kaliningrad Standard Time": "Europe/Kaliningrad",
  "Korea Standard Time": "Asia/Seoul",
  "Libya Standard Time": "Africa/Tripoli",
  "Line Islands Standard Time": "Pacific/Kiritimati",
  "Lord Howe Standard Time": "Australia/Lord_Howe",
  "Magadan Standard Time": "Asia/Magadan",
  "Magallanes Standard Time": "America/Punta_Arenas",
  "Marquesas Standard Time": "Pacific/Marquesas",
  "Mauritius Standard Time": "Indian/Mauritius",
  "Middle East Standard Time": "Asia/Beirut",
  "Montevideo Standard Time": "America/Montevideo",
  "Morocco Standard Time": "Africa/Casablanca",
  "Mountain Standard Time": "America/Denver",
  "Mountain Standard Time (Mexico)": "America/Mazatlan",
  "Myanmar Standard Time": "Asia/Rangoon",
  "N. Central Asia Standard Time": "Asia/Novosibirsk",
  "Namibia Standard Time": "Africa/Windhoek",
  "Nepal Standard Time": "Asia/Katmandu",
  "New Zealand Standard Time": "Pacific/Auckland",
  "Newfoundland Standard Time": "America/St_Johns",
  "Norfolk Standard Time": "Pacific/Norfolk",
  "North Asia East Standard Time": "Asia/Irkutsk",
  "North Asia Standard Time": "Asia/Krasnoyarsk",
  "North Korea Standard Time": "Asia/Pyongyang",
  "Omsk Standard Time": "Asia/Omsk",
  "Pacific SA Standard Time": "America/Santiago",
  "Pacific Standard Time": "America/Los_Angeles",
  "Pacific Standard Time (Mexico)": "America/Tijuana",
  "Pakistan Standard Time": "Asia/Karachi",
  "Paraguay Standard Time": "America/Asuncion",
  "Qyzylorda Standard Time": "Asia/Qyzylorda",
  "Romance Standard Time": "Europe/Paris",
  "Russia Time Zone 10": "Asia/Srednekolymsk",
  "Russia Time Zone 11": "Asia/Kamchatka",
  "Russia Time Zone 3": "Europe/Samara",
  "Russian Standard Time": "Europe/Moscow",
  "SA Eastern Standard Time": "America/Cayenne",
  "SA Pacific Standard Time": "America/Bogota",
  "SA Western Standard Time": "America/La_Paz",
  "SE Asia Standard Time": "Asia/Bangkok",
  "Saint Pierre Standard Time": "America/Miquelon",
  "Sakhalin Standard Time": "Asia/Sakhalin",
  "Samoa Standard Time": "Pacific/Apia",
  "Sao Tome Standard Time": "Africa/Sao_Tome",
  "Saratov Standard Time": "Europe/Saratov",
  "Singapore Standard Time": "Asia/Singapore",
  "South Africa Standard Time": "Africa/Johannesburg",
  "South Sudan Standard Time": "Africa/Juba",
  "Sri Lanka Standard Time": "Asia/Colombo",
  "Sudan Standard Time": "Africa/Khartoum",
  "Syria Standard Time": "Asia/Damascus",
  "Taipei Standard Time": "Asia/Taipei",
  "Tasmania Standard Time": "Australia/Hobart",
  "Tocantins Standard Time": "America/Araguaina",
  "Tokyo Standard Time": "Asia/Tokyo",
  "Tomsk Standard Time": "Asia/Tomsk",
  "Tonga Standard Time": "Pacific/Tongatapu",
  "Transbaikal Standard Time": "Asia/Chita",
  "Turkey Standard Time": "Europe/Istanbul",
  "Turks And Caicos Standard Time": "America/Grand_Turk",
  "US Eastern Standard Time": "America/Indianapolis",
  "US Mountain Standard Time": "America/Phoenix",
  "UTC": "Etc/UTC",
  "UTC+12": "Etc/GMT-12",
  "UTC+13": "Etc/GMT-13",
  "UTC-02": "Etc/GMT+2",
  "UTC-08": "Etc/GMT+8",
  "UTC-09": "Etc/GMT+9",
  "UTC-11": "Etc/GMT+11",
  "Ulaanbaatar Standard Time": "Asia/Ulaanbaatar",
  "Venezuela Standard Time": "America/Caracas",
  "Vladivostok Standard Time": "Asia/Vladivostok",
  "Volgograd Standard Time": "Europe/Volgograd",
  "W. Australia Standard Time": "Australia/Perth",
  "W. Central Africa Standard Time": "Africa/Lagos",
  "W. Europe Standard Time": "Europe/Berlin",
  "W. Mongolia Standard Time": "Asia/Hovd",
  "West Asia Standard Time": "Asia/Tashkent",
  "West Bank Standard Time": "Asia/Hebron",
  "West Pacific Standard Time": "Pacific/Port_Moresby",
  "Yakutsk Standard Time": "Asia/Yakutsk",
  "Yukon Standard Time": "America/Whitehorse",
}

/** Windows display label ("(UTC+01:00) Amsterdam, Berlin, ...") -> IANA zone. */
export const WINDOWS_ZONE_LABELS: Readonly<Record<string, string>> = {
  "(GMT+10:00) Canberra, Melbourne, Sydney": "Australia/Sydney",
  "(UTC) Casablanca": "Africa/Casablanca",
  "(UTC) Coordinated Universal Time": "Etc/UTC",
  "(UTC) Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London": "Europe/London",
  "(UTC) Monrovia, Reykjavik": "Atlantic/Reykjavik",
  "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna": "Europe/Berlin",
  "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague": "Europe/Budapest",
  "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris": "Europe/Paris",
  "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb": "Europe/Warsaw",
  "(UTC+01:00) West Central Africa": "Africa/Lagos",
  "(UTC+02:00) Amman": "Asia/Amman",
  "(UTC+02:00) Athens, Bucharest, Istanbul": "Europe/Bucharest",
  "(UTC+02:00) Beirut": "Asia/Beirut",
  "(UTC+02:00) Cairo": "Africa/Cairo",
  "(UTC+02:00) Harare, Pretoria": "Africa/Johannesburg",
  "(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius": "Europe/Kiev",
  "(UTC+02:00) Jerusalem": "Asia/Jerusalem",
  "(UTC+02:00) Minsk": "Europe/Chisinau",
  "(UTC+02:00) Windhoek": "Africa/Windhoek",
  "(UTC+03:00) Baghdad": "Asia/Baghdad",
  "(UTC+03:00) Kuwait, Riyadh": "Asia/Riyadh",
  "(UTC+03:00) Moscow, St. Petersburg, Volgograd": "Europe/Moscow",
  "(UTC+03:00) Nairobi": "Africa/Nairobi",
  "(UTC+03:00) Tbilisi": "Asia/Tbilisi",
  "(UTC+03:30) Tehran": "Asia/Tehran",
  "(UTC+04:00) Abu Dhabi, Muscat": "Asia/Dubai",
  "(UTC+04:00) Baku": "Asia/Baku",
  "(UTC+04:00) Baku, Tbilisi, Yerevan": "Asia/Yerevan",
  "(UTC+04:00) Port Louis": "Indian/Mauritius",
  "(UTC+04:00) Yerevan": "Asia/Yerevan",
  "(UTC+04:30) Kabul": "Asia/Kabul",
  "(UTC+05:00) Ekaterinburg": "Asia/Yekaterinburg",
  "(UTC+05:00) Islamabad, Karachi": "Asia/Karachi",
  "(UTC+05:00) Tashkent": "Asia/Tashkent",
  "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi": "Asia/Calcutta",
  "(UTC+05:45) Kathmandu": "Asia/Katmandu",
  "(UTC+06:00) Almaty, Novosibirsk": "Asia/Novosibirsk",
  "(UTC+06:00) Astana, Dhaka": "Asia/Bishkek",
  "(UTC+06:00) Sri Jayawardenepura": "Asia/Colombo",
  "(UTC+06:30) Yangon (Rangoon)": "Asia/Rangoon",
  "(UTC+07:00) Bangkok, Hanoi, Jakarta": "Asia/Bangkok",
  "(UTC+07:00) Krasnoyarsk": "Asia/Krasnoyarsk",
  "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi": "Asia/Shanghai",
  "(UTC+08:00) Irkutsk, Ulaanbaatar": "Asia/Irkutsk",
  "(UTC+08:00) Kuala Lumpur, Singapore": "Asia/Singapore",
  "(UTC+08:00) Perth": "Australia/Perth",
  "(UTC+08:00) Taipei": "Asia/Taipei",
  "(UTC+09:00) Osaka, Sapporo, Tokyo": "Asia/Tokyo",
  "(UTC+09:00) Seoul": "Asia/Seoul",
  "(UTC+09:00) Yakutsk": "Asia/Yakutsk",
  "(UTC+09:30) Adelaide": "Australia/Adelaide",
  "(UTC+09:30) Darwin": "Australia/Darwin",
  "(UTC+10:00) Brisbane": "Australia/Brisbane",
  "(UTC+10:00) Canberra, Melbourne, Sydney": "Australia/Sydney",
  "(UTC+10:00) Guam, Port Moresby": "Pacific/Port_Moresby",
  "(UTC+10:00) Hobart": "Australia/Hobart",
  "(UTC+10:00) Vladivostok": "Asia/Vladivostok",
  "(UTC+11:00) Magadan, Solomon Islands, New Caledonia": "Pacific/Guadalcanal",
  "(UTC+12:00) Auckland, Wellington": "Pacific/Auckland",
  "(UTC+12:00) Fiji, Kamchatka, Marshall Is.": "Pacific/Fiji",
  "(UTC+12:00) Petropavlovsk-Kamchatsky": "Asia/Kamchatka",
  "(UTC+13:00) Nuku'alofa": "Pacific/Tongatapu",
  "(UTC-01:00) Azores": "Atlantic/Azores",
  "(UTC-01:00) Cape Verde Islands": "Atlantic/Cape_Verde",
  "(UTC-02:00) Mid-Atlantic": "Etc/GMT+2",
  "(UTC-03:00) Brasilia": "America/Sao_Paulo",
  "(UTC-03:00) Buenos Aires": "America/Buenos_Aires",
  "(UTC-03:00) Georgetown": "America/Cayenne",
  "(UTC-03:00) Greenland": "America/Godthab",
  "(UTC-03:00) Montevideo": "America/Montevideo",
  "(UTC-03:30) Newfoundland": "America/St_Johns",
  "(UTC-04:00) Asuncion": "America/Asuncion",
  "(UTC-04:00) Atlantic Time (Canada)": "America/Halifax",
  "(UTC-04:00) Georgetown, La Paz, San Juan": "America/La_Paz",
  "(UTC-04:00) Manaus": "America/Cuiaba",
  "(UTC-04:00) Santiago": "America/Santiago",
  "(UTC-04:30) Caracas": "America/Caracas",
  "(UTC-05:00) Bogota, Lima, Quito": "America/Bogota",
  "(UTC-05:00) Eastern Time (US & Canada)": "America/New_York",
  "(UTC-05:00) Eastern Time (US and Canada)": "America/New_York",
  "(UTC-05:00) Indiana (East)": "America/Indianapolis",
  "(UTC-06:00) Central America": "America/Guatemala",
  "(UTC-06:00) Central Time (US & Canada)": "America/Chicago",
  "(UTC-06:00) Central Time (US and Canada)": "America/Chicago",
  "(UTC-06:00) Guadalajara, Mexico City, Monterrey": "America/Mexico_City",
  "(UTC-06:00) Guadalajara, Mexico City, Monterrey - New": "America/Mexico_City",
  "(UTC-06:00) Saskatchewan": "America/Regina",
  "(UTC-07:00) Arizona": "America/Phoenix",
  "(UTC-07:00) Chihuahua, La Paz, Mazatlan": "America/Mazatlan",
  "(UTC-07:00) Chihuahua, La Paz, Mazatlan - New": "America/Mazatlan",
  "(UTC-07:00) Mountain Time (US & Canada)": "America/Denver",
  "(UTC-07:00) Mountain Time (US and Canada)": "America/Denver",
  "(UTC-08:00) Pacific Time (US & Canada); Tijuana": "America/Los_Angeles",
  "(UTC-08:00) Pacific Time (US and Canada); Tijuana": "America/Los_Angeles",
  "(UTC-08:00) Tijuana, Baja California": "America/Tijuana",
  "(UTC-09:00) Alaska": "America/Anchorage",
  "(UTC-10:00) Hawaii": "Pacific/Honolulu",
  "(UTC-11:00) Midway Island, Samoa": "Pacific/Apia",
  "(UTC-12:00) International Date Line West": "Etc/GMT+12",
}
